module.exports = __webpack_public_path__ + "img/title2.b2e404e3.png";